/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta, IRespuestaPaginada } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFiltrosItem from './entidades/filtrosItem';
import IItem from './entidades/item';
import IItemCompuesto from './entidades/itemCompuesto';
import IParametrosItem from './entidades/parametrosItem';
import IProductoPrincipal from './entidades/productoPrincipal';
import IMaximosMinimos from '../maximosMinimos/entidades/IMaximosMinimos';

export default class ModeloProducto {
    public consultarListaProductoPrincipal(parametros: IParametrosItem) {
        return manejadorRest<IRespuestaPaginada<IProductoPrincipal>>(
            () => negocioConfiguracion.post('Item/ConsultarListaItemCompuestos', parametros),
            true
        );
    }

    public consultarListaProductoPrincipalmax(parametros: IParametrosItem) {
        return manejadorRest<IRespuestaPaginada<IMaximosMinimos>>(
            () => negocioConfiguracion.post('Item/ConsultarListaItemCompuestos', parametros),
            true
        );
    }

    public consultarItemPorCodigoBarras(codigoBarras: string) {
        return manejadorRest<IRespuesta<IProductoPrincipal>>(
            () => negocioConfiguracion.get(`Item/ConsultarItemPorCodigoBarras?CodigoBarras=${codigoBarras}`),
            true
        );
    }

    public consultarListaItemsPorFiltro(filtros: IFiltrosItem) {
        return manejadorRest<IRespuesta<IProductoPrincipal>>(
            () => negocioConfiguracion.post('Item/ConsultarListaItemCompuestosFiltro', filtros),
            true
        );
    }

    public guardarItemUnidades(ItemCompuesto: IItemCompuesto) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocioConfiguracion.post('Item/GuardarItemUnidad', ItemCompuesto),
            true
        );
    }

    public editarItemUnidades(ItemCompuesto: IItemCompuesto) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocioConfiguracion.put('Item/EditarItemUnidad', ItemCompuesto),
            true
        );
    }

    public eliminarItem(item: IItem) {
        return manejadorRest<IRespuesta<IItemCompuesto>>(
            () => negocioConfiguracion.delete('Item/EliminarItemCompuesto', item),
            true
        );
    }

    public consultarListaItems() {
        return manejadorRest<IRespuesta<IItem>>(() => negocioConfiguracion.get('Item/ConsultarListaItem'), true);
    }
}
